import React, { useState } from 'react';
import styled from 'styled-components';
import {
  ButtonIcon,
  IconMenu,
  IconX,
  NavBar,
  NavBarList,
  NavBarListItem,
  Type,
} from '@spotify-internal/encore-creator-web';
import {
  gray10,
  white,
  spacer8,
  spacer16,
  spacer20,
  spacer24,
  spacer48,
  screenMdMin,
} from '@spotify-internal/encore-foundation';
import SpotifyForPodcastersMobileLogo from '../../svg/podcasters-mobile-logo.svg';
import { SpotifyForPodcastersLogo } from '../../vendor/SpotifyForPodcastersLogo';
import { getAuthUrl } from './utils/getAuthUrl';
import { pageConstraintStyles } from './styles';
import { useMe } from '../../hooks/useMe';

export function Header() {
  const me = useMe();
  const [showPanel, setShowPanel] = useState(false);

  return (
    <>
      <HeaderContainer>
        <Logo>
          <SpotifyForPodcastersLogo />
        </Logo>
        <MobileLogo src={SpotifyForPodcastersMobileLogo} />
        <HeaderNavBar
          list={
            <NavBarList>
              <HeaderNavItem
                label="News"
                href={`${window.location.origin}/blog`}
                style={{ color: white }}
                sentenceCase
              />
              <HeaderNavItem
                label="FAQ"
                href={`${window.location.origin}/faq`}
                style={{ color: white }}
                sentenceCase
              />
              <HeaderNavItem
                href={getAuthUrl(me)}
                label={me ? 'Your Dashboard' : 'Log In'}
                style={{ color: white }}
                sentenceCase
              />
            </NavBarList>
          }
        />
        <MobileHamburger aria-label="IconMenu" onClick={() => setShowPanel(true)} />
      </HeaderContainer>
      {showPanel && (
        <NavPanel data-testid="landing-page--nav-panel">
          <ButtonIcon
            onClick={() => setShowPanel(false)}
            style={{ position: 'absolute', top: spacer24, right: spacer16 }}
          >
            <IconX aria-label="Close" color={white} />
          </ButtonIcon>
          <PanelLink href={`${window.location.origin}/blog`}>
            <PanelLinkText>News</PanelLinkText>
          </PanelLink>
          <PanelLink href={`${window.location.origin}/faq`}>
            <PanelLinkText>FAQ</PanelLinkText>
          </PanelLink>
          <PanelLink href={getAuthUrl(me)}>
            <PanelLinkText>{me ? 'Your Dashboard' : 'Log In'}</PanelLinkText>
          </PanelLink>
        </NavPanel>
      )}
    </>
  );
}

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${spacer16} ${spacer16} 0;

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}

    padding: 0 ${spacer48};
  }
`;

const Logo = styled.div`
  width: 280px;
  height: 40px;
  display: none;

  @media (min-width: ${screenMdMin}) {
    display: block;
  }
`;

const MobileLogo = styled.img`
  @media (min-width: ${screenMdMin}) {
    display: none;
  }
`;

const HeaderNavBar = styled(NavBar)`
  display: none;

  @media (min-width: ${screenMdMin}) {
    display: block;
    padding: ${spacer20} 0 ${spacer8};
  }
`;

const HeaderNavItem = styled(NavBarListItem).attrs({
  sentenceCase: true,
})`
  color: ${white};
`;

const MobileHamburger = styled(IconMenu)`
  @media (min-width: ${screenMdMin}) {
    display: none;
  }
`;

const NavPanel = styled.div`
  background-color: ${gray10};
  width: 100%;
  height: 100%;
  padding: 38px;
  position: fixed;
  top: 0;
  z-index: 10;
`;

const PanelLink = styled.a`
  color: ${white};
`;

const PanelLinkText = styled(Type).attrs({
  forwardedAs: 'p',
  weight: Type.bold,
})`
  font-size: 36px;
  line-height: 1;
`;
